module.exports = __webpack_public_path__ + "static/media/tomaC.c881cc18.jpg";